import React, { Component } from 'react'
import back5 from '../Assets/back5.jpeg';
import resume from '../Assets/resume.pdf';
import nitinkumarCV from '../Assets/nitinkumarCV.pdf';

export default class Aboutme extends Component {
    render() {
        return (
            <div id="about-page" className="about-me">
                <div className="text-box">
                    <div className="About-para">
                        <h1 className="About-heading">Get to know me!</h1>
                        
                        <p className='mysection'>
                        An enthusiastic and creative possibilist with highly motivated
                        leadership skills, I am always 
                        eager to learn new technologies to innovate or improve 
                        existing ones with the right balance of perseverance and 
                        smart work. I am intrigued by designing, Web development, App 
                        development and conversant with many programming languages.
                        Also worked on many other technologies like Gatsbyjs, Contentful.
                        <br/><br/>
                        I always want to give my best and keep evolving, thus, need an 
                        opportunity to utilize my years of learning experience, and 
                        creativity and add value to company using my innovative ideas 
                        and logical thinking. 
                        <br/><br/>
                        My defence background, over the years has helped
                        me develop and showcase adaptibility and agility in my work as well as 
                        my social circle.
                        <br/><br/>
                        Apart from academics, I also invest time workingout in gym, playing 
                        basketball and helping my mother in household chores.
                        </p>
                    </div>
                    <div className="button-position">
                        <a href={resume} download='nitin kumar resume'>
                            <button className="resume-btn">Download Resume</button>
                        </a>
                    </div>
                    <div className="button-position-cv">
                        <a href={nitinkumarCV} download='nitin kumar CV'>
                            <button className="cv-btn">Download CV</button>
                        </a>
                    </div>
                </div>
            <img className="image-box" src={back5} alt=""/>
            </div>
        )
    }
}
